import { connection } from '@/api/connection'

export default {
  postAnonymizeCustomer ({ customerId }) {
    return connection.post(`bo/anonymization/customer/${customerId}`)
  }
}
